import React, { Fragment } from 'react';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

export const SECTIONS_WRAPPER_ID = 'sections-wrapper';

const SectionsWrapperUi_ViewerVersion1 = ({ children })=>
  <Fragment>{ children }</Fragment>;

const SectionsWrapperUi_ViewerVersion2 = ({ children })=>
  <main id={SECTIONS_WRAPPER_ID}>{ children }</main>;

const SectionsWrapperUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SectionsWrapperUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SectionsWrapperUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SectionsWrapperUi;
